import { render } from "./CotizacionesPage.vue?vue&type=template&id=d0699a3a&scoped=true"
import script from "./CotizacionesPage.vue?vue&type=script&lang=js"
export * from "./CotizacionesPage.vue?vue&type=script&lang=js"

import "./CotizacionesPage.vue?vue&type=style&index=0&id=d0699a3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0699a3a"]])

export default __exports__